/**
 * Entry point. The provider order matters:
 *
 *   ErrorBoundary        catches a crash in *any* provider below it
 *     QueryClientProvider  data, before anything that reads it
 *       ThemeProvider      paints `data-theme` before the first component render
 *         TooltipProvider  one shared delay/skip window for every tooltip
 *           App + Toaster  the toaster sits outside the router so a toast
 *                          survives a route change
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

import './index.css';

import { App } from '@/App';
import { ErrorBoundary } from '@/components/app/ErrorBoundary';
import { Toaster, TooltipProvider } from '@/components/ui';
import { queryClient } from '@/lib/queries';
import { ThemeProvider } from '@/lib/theme';

const container = document.getElementById('root');
if (!container) throw new Error('AlphaForm CRM: #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TooltipProvider>
            <App />
            <Toaster />
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
